<template>
	<div class="stu_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="stu_cont">
			<div class="top_title">
				<div class="goback" @click="goBack()"><img src="/static/images/course/icon-3.png"/><span>返回</span></div>
				<i></i>
				<b>学员列表</b>
			</div>
			<h3>{{$route.query.className}}</h3>
			<div class="ipt">
				<div class="seach_ipt">
					<el-input v-model="nameSum" placeholder="请输入姓名/学号/手机号" @keyup.enter.native="sreach()"></el-input>
					<div class="select">
						<span>行政班级</span><i></i>
						<el-select v-model="className" placeholder="请选择" clearable @change="sreach">
					    <el-option
					      v-for="item in options"
					      :key="item"
					      :label="item"
					      :value="item">
					    </el-option>
					  </el-select>
					</div>
					<el-button type="primary" icon="el-icon-search" @click="sreach()">查询</el-button>
				</div>
			</div>
			<div class="table">
				<el-table
			    ref="multipleTable"
			    :data="tableData"
			    tooltip-effect="dark"
			    style="width: 100%"
			    :height="height"
			    >
			    <el-table-column label="序号" type="index" width="50">
			    	<template slot-scope="scope">{{(pageTotal.currentPage - 1) * pageTotal.pageSize + scope.$index + 1}}</template>
			    </el-table-column>
			    <el-table-column label="姓名" prop="studentName"></el-table-column>
			    <el-table-column label="学号" prop="jobNumber"></el-table-column>
			    <el-table-column label="手机号" prop="mobile">
            <template slot-scope="scope">
              <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
            </template>
          </el-table-column>
			    <el-table-column label="加入方式" prop="joinType">
			    	<template slot-scope="scope">{{ scope.row.joinType == '0'?'录入':'邀请码' }}</template>
			    </el-table-column>
			    <el-table-column label="行政班级" prop="className"></el-table-column>
			    <template slot="empty">
	        	<img src="/static/images/wujieguo.png"/>
	        	<p>暂无学员</p>
	        </template>
			  </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageTotal.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageTotal.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next"
          :total="pageTotal.total"
          class="paginator"
        ></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
  import * as api from "@/api/individualApi";
  import * as api1 from "@/api/HNstatisticsApi"
  import {desensitization} from "@/utils/utils";
	export default {
    filters:{
      desensitizationText(val){
        return desensitization(val)
      }
    },
		data(){
			return {
	      loading: true,
	      height: null,
				nameSum:'',
				options: [],
        className:'',
        tableData: [],
        pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
			}
		},
		created(){
			this.getStudentList();
			this.getTeachingClass();
		},
		methods:{
			// 返回
			goBack() {
				this.$router.go(-1);
     	},
			// 获取学生列表
			getStudentList(){
				let obj = {
					"param": this.nameSum,
					"className": this.className,
					"classId": this.$route.query.classId,
					"page": this.pageTotal.currentPage,
					"limit": this.pageTotal.pageSize,
					"status": 1
        }
				api1.getUserInfo(obj).then(res=>{
					if(res.code == 0){
						this.loading = false;
						this.tableData = res.data.list;
						this.pageTotal.total = res.data.total;
						this.pageTotal.currentPage = res.data.pageNum;
						this.height = window.innerHeight - 260+"px";
					}else{
						this.loading = false;
						this.$messageError(res.msg);
					}
				}).catch(error => {});
			},
			handleCurrentChange(val) {
	      this.pageTotal.currentPage = val;
	      this.getStudentList();
	   	},
	   	handleSizeChange(val){
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getStudentList();
	   	},
	   	// 获取行政班级
	   	getTeachingClass(){
	   		api.getTeachingClass().then(res=>{
	   			if(res.code == 0){
	   				this.options = res.data;
	   			}
	   		})
	   	},
	    // 查询
	    sreach(){
        this.loading = true;
	     	this.handleCurrentChange(1)
	    },
		}
	}
</script>

<style scoped lang="scss">
	.stu_wrap {
		background: #F6F8FB;
		.stu_cont {
			margin: 16px;
			margin-bottom: 0;
			background: #fff;
		}
		.top_title {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding: 20px 0;
			margin: 0 16px;
			border-bottom: 1px solid #DDE0E2;
			.goback {
				display: flex;
				align-items: center;
				font-size: 12px;
				cursor: pointer;
				img {
					display: inline-block;
					width: 18px;
					height: 18px;
					margin-right: 8px;
				}
			}
			i {
				width:4px;
				height:12px;
				background:rgba(83,151,247,1);
				margin: 0 10px;
			}
			b {
				font-size: 16px;
				color: #0D141E;
				font-weight: bold;
			}
		}
		h3 {
			font-size: 16px;
			color: #0D141E;
			margin-top: 20px;
			margin-bottom: 16px;
			padding: 0 24px;
			font-weight: bold;
		}
		.ipt {
			display: flex;
			justify-content: space-between;
			padding: 0 20px;
			/deep/ .el-input {
				width: 298px;
				float: left;
				.el-input__inner {
					height: 32px;
					line-height: 32px;
					border: 0;
					background: #F1F2F4;
					border-radius: 2px;
				}
			}
			.select {
				float: left;
				width: 230px;
				height: 32px;
				background: #F1F2F4;
				margin-left: 16px;
				border-radius: 2px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				span {
					font-size: 12px;
					color: #A0A0A6;
					margin-left: 14px;
				}
				i {
					width:0px;
					height:16px;
					border:1px solid rgba(188,188,194,1);
				}
				/deep/ .el-input {
					width: 126px;
					.el-input__icon {
						line-height: 32px;
					}
				}
			}
			/deep/ .el-button {
				padding: 8px 0;
				width: 72px;
				text-align: center;
				margin-left: 14px;
				border-color: #5397F7;
				span {
					font-size: 12px;
				}
			}
			/deep/ .el-button--default {
				span {
					color: #5397F7;
				}
			}
		}
		.table {
			padding: 0 20px;
			/deep/ .el-table {
				td .cell {
					height: 40px;
					line-height: 40px;
					background: #F6F8FB;
					margin-bottom: 8px;
					span {
						cursor: pointer;
						color: #5397F7;
					}
				}
				th {
					.cell {
						background: transparent;
					}
				}
				td,th {
					padding: 0;
					height: 40px;
				}
				/deep/ tr {
					&:hover {
						background: transparent !important;
					}
				}
				td {
					padding-bottom: 8px;
				}
				td,th.is-leaf {
					border: 0;
				}
				th.is-leaf {
					&:nth-child(1) {
						padding-left: 3px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classStatistics/studentList.vue